"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMenu = void 0;
var DotsVerticalIcon_1 = __importDefault(require("mdi-react/DotsVerticalIcon"));
var react_1 = __importStar(require("react"));
var Icon_1 = require("../Icon");
var IconButton_1 = require("../IconButton");
var Menu_1 = require("../Menu");
var styles_1 = require("../styles");
var ITEM_HEIGHT = 40;
var styles = {
    'iconButton--light': {
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.08)',
        },
    },
    menu: {
        '& *': {
            outline: 'none',
        },
    },
};
function UnstyledIconMenu(_a) {
    var icon = _a.icon, iconElement = _a.iconElement, _b = _a.variant, variant = _b === void 0 ? 'dark' : _b, renderItems = _a.renderItems, IconButtonProps = _a.IconButtonProps, classes = _a.classes, theme = _a.theme, other = __rest(_a, ["icon", "iconElement", "variant", "renderItems", "IconButtonProps", "classes", "theme"]);
    var _c = (0, react_1.useState)(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClose = function (onClickHandler) {
        if (onClickHandler === void 0) { onClickHandler = null; }
        return function () {
            setAnchorEl(null);
            if (
            // https://stackoverflow.com/questions/5999998/how-can-i-check-if-a-javascript-variable-is-function-type
            onClickHandler &&
                {}.toString.call(onClickHandler) === '[object Function]') {
                onClickHandler();
            }
        };
    };
    var color = variant === 'light'
        ? theme.palette.common.white
        : theme.palette.text.primary;
    var className = variant === 'light' ? classes['iconButton--light'] : '';
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(IconButton_1.IconButton, __assign({}, IconButtonProps, { classes: {
                root: className,
            }, "aria-owns": anchorEl ? 'icon-menu' : null, "aria-haspopup": "true", onClick: function (event) { return setAnchorEl(event.currentTarget); } }), iconElement !== null && iconElement !== void 0 ? iconElement : (icon
            ? react_1.default.createElement(Icon_1.Icon, { color: color }, icon)
            : react_1.default.createElement(DotsVerticalIcon_1.default, null))),
        react_1.default.createElement(Menu_1.Menu, __assign({ className: classes.menu, id: "icon-menu", anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose(), PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 5.5,
                },
            } }, other), renderItems(handleClose))));
}
exports.IconMenu = (0, styles_1.withStyles)(styles, { withTheme: true })(UnstyledIconMenu);
exports.default = exports.IconMenu;
//# sourceMappingURL=index.js.map